<script lang="ts" setup>
import { KaBadge } from '@/kasten-components';
import { useAppInfoStore } from '@/stores/appInfo';

const appInfoStore = useAppInfoStore();
</script>
<template>
  <footer
    class="mt-20 flex flex-wrap items-center justify-between gap-x-4 gap-y-1 border-t border-black/10 p-4 text-sm dark:border-navy-600 sm:px-6"
    :class="{ 'print:hidden': $route.name === 'ReportDetails' }"
    data-testid="footer"
  >
    <span>© {{ new Date().getFullYear() }} Kasten, Inc.</span>
    <div class="flex min-w-0 max-w-full items-center gap-3" data-testid="footer-meta">
      <span
        v-if="appInfoStore.systemVersion"
        class="min-w-0 truncate italic"
        :title="`version ${appInfoStore.systemVersion}`"
        data-testid="deployment-version"
      >
        version {{ appInfoStore.systemVersion }}
      </span>
      <KaBadge
        v-if="appInfoStore.isFIPS"
        color="green"
        class="shrink-0"
        data-testid="fips-badge-footer"
      >
        FIPS
      </KaBadge>
    </div>
  </footer>
</template>
